export default {
  title: "Todo invoices: {{total}}"
}
